import palettesVRJson from '../../meta/palettesVR.json';

let palettesVRData = palettesVRJson;

palettesVRData = palettesVRData.map(item => ({ ...item, name: item.name.trim() })); // elimina espacios exteriores que provocan errores

palettesVRData.sort((a, b) => a.name.localeCompare(b.name)); // ordena alfabeticamente

// pendiente de aclarar como usar una paleta default
// const foundIndex = palettesVRData.findIndex(item => item.name === 'Muscle');
// if (foundIndex > 0) {
//     const [foundElem] = palettesVRData.splice(foundIndex, 1);
//     palettesVRData.unshift(foundElem);
// }

export const palettesVR = palettesVRData;